import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';


@Component({
    selector: 'score-board-modal',
    templateUrl: 'score-board-modal.html',
    styleUrls:['./score-board-modal.scss']
  })

  export class ScoreBoardModal {

    scoreBoardArray = [];
    places: any = [];
    wallenArray = [];
    isWallen: boolean = false;
    routerState:any;

      constructor (private storage: StorageProvider,
      private navCtrl: NavController, private router:Router) {
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};
        this.getAthletes();
        this.getArray();
        this.getPlaces();
      }

      getPlaces() {
        for(let i = 0; i < this.scoreBoardArray.length; i++) {
          this.scoreBoardArray[i].place = i + 1;
        }
        console.log(JSON.stringify(this.scoreBoardArray)+ "SCORE BOARD ARRAY");
      }

      async getAthletes(){
        await this.storage.getSaved('score-board').then((data) => this.scoreBoardArray = data);
        console.log("athletes" + this.scoreBoardArray);
      }
      
      async getArray() {
         this.wallenArray = this.wallenArray.concat(this.routerState['array']);
         this.isWallen = true;
      }

      onBackMenu() {
        this.wallenArray.length = 0;
        this.navCtrl.pop();
      }
  }